module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myupload"
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "on-preview": _vm.uploadPreview,
      "data": _vm.upload.data,
      "headers": _vm.headers,
      "action": _vm.upload.postURL,
      "show-file-list": false,
      "on-success": _vm.uploadSuccess,
      "http-request": _vm.submitUpload,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('span', [_vm._v("上传图片")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d4cf34d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/primary/Uploadtop.vue
// module id = 1116
// module chunks = 1